import {
  PRODUCT_TRANSACTION_TYPES_ALL,
  PRODUCT_TRANSACTION_TYPES_GET,
  PRODUCT_TRANSACTION_TYPES_DEL,
  PRODUCT_TRANSACTION_TYPES_PUT,
  PRODUCT_TRANSACTION_TYPES_POST,
  PRODUCT_TRANSACTION_TYPES_LOADING,
  PRODUCT_TRANSACTION_TYPES_ERROR,
} from '../../actions/types';

const initialState = {
  productTransactionType: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PRODUCT_TRANSACTION_TYPES_LOADING:
      return { isLoading: true, isCompleted: true };
    case PRODUCT_TRANSACTION_TYPES_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case PRODUCT_TRANSACTION_TYPES_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PRODUCT_TRANSACTION_TYPES_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PRODUCT_TRANSACTION_TYPES_POST:
      return { isLoading: false, isCompleted: true };
    case PRODUCT_TRANSACTION_TYPES_PUT:
      return { isLoading: false, isCompleted: true };
    case PRODUCT_TRANSACTION_TYPES_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
